const useStateUpdate = (updateState, object) => {
  const updateFormObject = (e) => {
    const name = e.target.name
    const value = e.target.value
    updateState({ ...object, [name]: value })
  }

  const updateFormObjectProp = (prop, value) => {
    updateState({ ...object, [prop]: value })
  }

  return [updateFormObject, updateFormObjectProp]
}

export default useStateUpdate